<template>
  <div>
    <div class="wrapo">
      <nav class="navbar navbar-expand-lg header">
        <a class="hvr ml-1" style="padding-left: 30px; padding-top:12px; padding-right:20px; padding-bottom:12px;" href="https://circl.it/"><img src="https://circl.it/wp-content/themes/Circl-Child/assets/logo-white.png" height="18" width="62"></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
          <img src="https://i.ya-webdesign.com/images/white-bar-png-15.png" height="28" width="36"/>
        </button>
        <div class="collapse navbar-collapse" id="navbarText">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item active"><a class="font-3 hvr mr-3" href="https://circl.it/">I’m a Merchant</a></li>
            <li class="nav-item"><a class="font-3 hvr mr-3" href="https://circl.it/foodtrail/">FoodTrail</a></li>
            <li class="nav-item"><a style="color: white;" class="font-3 hvr mr-3" href="https://store.circl.it/pricing">Pricing</a></li>
            <li class="nav-item"><a class="font-3 hvr mr-3" href="https://circl.it/start">Get Started</a></li>
            <li class="nav-item"><a class="font-3 hvr mr-3" href="https://circl.it/about/">About</a></li>
            <li class="nav-item"><a class="font-3 hvr mr-3" @click="open()">Merchant Login</a></li>
          </ul>
        </div>
      </nav>
      <h4 class="align-self-center mt-5 mb-2">All-in-one Platform</h4>
      <h4 class="align-self-center font-1 mt-5 mb-2">0% Commission</h4>
      <p class="align-self-center mt-2 mb-4">for dine-in and takeaway</p>
      <div class="card-subscription-wrapper">
        <!-- <CardSubscription :subscriptionPlan="subs_plan_1" :showMonthly="show_monthly" style="margin-top: 66px;"/> -->
        <!-- <CardSubscription :subscriptionPlan="subs_plan_1" :showMonthly="show_monthly" :showButton="true" :showFreeTrial="show_free_trial"/> -->
        <CardSubscription :subscriptionPlan="subs_plan_1" :showButton="true" :showFreeTrialAndCoupon="true" :showPriceByDay="true"/>
        <CardSubscription :subscriptionPlan="subs_plan_2" :showButton="true" :showFreeTrialAndCoupon="true" :showPriceByDay="true"/>
        <CardSubscription :subscriptionPlan="subs_plan_3" :showButton="true" :showFreeTrialAndCoupon="true" :showPriceByDay="true"/>
        <!-- <div class="d-flex flex-column">
          <div class="d-flex flex-row mb-4 align-self-center">
            <p class="font-2">Bill yearly</p>
            <label class="switch ml-3 mr-3"><input type="checkbox"><span @click="switchPlan()" class="slider round"></span></label>
            <p class="font-2" >Bill monthly</p>
          </div>
          <CardSubscription :subscriptionPlan="subs_plan_2" :showMonthly="show_monthly" :showButton="true" :showFreeTrial="show_free_trial"/>
        </div> -->
        <!-- <CardSubscription :subscriptionPlan="subs_plan_3" :showMonthly="show_monthly" :showButton="true" style="margin-top: 66px;" /> -->
      </div>
      <h4 class="align-self-center mb-2">Options</h4>
      <div class="d-flex flex-column">
        <div class="align-self-center card-option-wrapper mb-5">
          <div class="d-flex flex-column justify-content-start">
            <p v-if="!sg" class="align-self-start text-left mt-1 ml-3 mr-3">• <b>$1</b> per delivery order</p>
            <p v-if="!sg" class="align-self-start text-left mt-1 ml-3 mr-3">• <b>$0.25</b> per curbside pickup</p>
            <p v-if="!sg" class="align-self-start text-left mt-1 ml-3 mr-3">• <b>$0.25</b> per loyalty / reward / promo redemption</p>
            <p v-if="!sg" class="align-self-start text-left mt-1 ml-3 mr-3">• Additional device licenses: <b>$60 | $45 | $30</b></p>
            <p v-if="!sg" class="align-self-start text-left mt-1 ml-3 mr-3">• Menu set-up(waived for 2 years prepay): From <b>$300</b></p>
            <p v-if="!sg" class="align-self-start text-left mt-1 ml-3 mr-3">• Waterproof QR decal: <b>$5</b></p>
            <p v-if="!sg" class="align-self-start text-left mt-1 ml-3 mr-3">• Secure Bluetooth printer with PIN: <b>$100</b></p>

            <p v-if="sg" class="align-self-start text-left mt-1 ml-3 mr-3">• <b>S$1.35</b> per delivery order</p>
            <p v-if="sg" class="align-self-start text-left mt-1 ml-3 mr-3">• <b>S$0.35</b> per curbside pickup</p>
            <p v-if="sg" class="align-self-start text-left mt-1 ml-3 mr-3">• <b>S$0.35</b> per loyalty / reward / promo redemption</p>
            <p v-if="sg" class="align-self-start text-left mt-1 ml-3 mr-3">• Additional device licenses: <b>S$82 | S$61 | S$41</b></p>
            <p v-if="sg" class="align-self-start text-left mt-1 ml-3 mr-3">• Menu set-up(waived for 2 years prepay): From <b>S$400</b></p>
            <p v-if="sg" class="align-self-start text-left mt-1 ml-3 mr-3">• Waterproof QR decal: <b>S$6.75</b></p>
            <p v-if="sg" class="align-self-start text-left mt-1 ml-3 mr-3">• Secure Bluetooth printer with PIN: <b>S$135</b></p>
          </div>
        </div>
        <button @click="toSG()" v-if="!sg" class="align-self-center mb-5 button-sg-pricing"><h4>Go to Singapore Pricing</h4></button>
        <button @click="toGlobal()" v-if="sg" class="align-self-center mb-5 button-sg-pricing"><h4>Go to Global Pricing</h4></button>
        <div class="additional-info-wrapper align-self-center mb-5">
          <p v-if="!sg" class="text-left mb-1">• Billing amounts:  $60 for Monthly Billing plan.  $547.5/year for Annual Billing plan.  $730 upfront + $365 in years 3+ for the “Prepaid then Annual” plan.</p>
          <p v-if="!sg" class="text-left mb-1">• An additional device license is needed for each additional device, e.g. bar, kitchen, delivery courier, other outlets – and will be billed monthly according to the selected plan.</p>
          <p v-if="!sg" class="text-left mb-1">• Fees for optional services are billed monthly.  Menu set-up, decals, and printers are billed in advance.  Fees may be deducted from payouts or charged to card-on-file.</p>
          <p v-if="!sg" class="text-left mb-1">• Standard payment processing fees apply for online payments, as published on Stripe.com.  Automatic monthly bank payout.  Additional payouts: $1 each.</p>
          <p v-if="!sg" class="text-left mb-1">• Pricing is in USD.  Cancel anytime, but at least 1 day before next billing to avoid being billed.</p>

          <p v-if="sg" class="text-left mb-1">• Billing amounts:  S$82 for Monthly Billing plan. S$730/year for Annual Billing plan. S$986 upfront + S$493 in years 3+ for the “Prepaid then Annual” plan.</p>
          <p v-if="sg" class="text-left mb-1">• An additional device license is needed for each additional device, e.g. bar, kitchen, delivery courier, other outlets – and will be billed monthly according to the selected plan.</p>
          <p v-if="sg" class="text-left mb-1">• Fees for optional services are billed monthly.  Menu set-up, decals, and printers are billed in advance.  Fees may be deducted from payouts or charged to card-on-file.</p>
          <p v-if="sg" class="text-left mb-1">• Standard payment processing fees apply for online payments, as published on Stripe.com.  Automatic monthly bank payout.  Additional payouts: $1.35 each.</p>
          <p v-if="sg" class="text-left mb-1">• Cancel anytime, but at least 1 day before next billing to avoid being billed.</p>
        </div>
      </div>
      <!-- <ul class="card-subscription-wrapper">
        <li class="text-justify mb-1">Billing amounts:  $60 for Monthly Billing plan.  $547.5/year for Annual Billing plan.  $730 upfront + $365 in years 3+ for the “Prepaid then Annual” plan.</li>
        <li class="text-justify mb-1">An additional device license is needed for each additional device, e.g. bar, kitchen, delivery courier, other outlets – and will be billed monthly according to the selected plan.</li>
        <li class="text-justify mb-1">Fees for optional services are billed monthly.  Menu set-up, decals, and printers are billed in advance.  Fees may be deducted from payouts or charged to card-on-file.</li>
        <li class="text-justify mb-1">Standard payment processing fees apply for online payments, as published on Stripe.com.  Automatic monthly bank payout.  Additional payouts: $1 each.</li>
        <li class="text-justify mb-1">Pricing is in USD.  Cancel anytime, but at least 1 day before next billing to avoid being billed. </li>
      </ul> -->
      <div class="footer d-flex flex-row flex-wrap">
        <div class="d-flex flex-column footer-content-left">
          <p class="font-4 d-flex align-self-start mt-5 mb-0">Get our Apps</p>
          <p class="font-6 d-flex align-self-start mt-4 mb-0">For Ordering:  CIRCL</p>
          <a class="align-self-start mt-4" href="https://apps.apple.com/us/app/circl-it/id1294948134?ls=1" target="_blank"><img class="hvr" src="https://circl.it/wp-content/uploads/2019/05/appstore-button-300x101.png" style="width: 140px; height: 50px;"/></a>
          <a class="align-self-start mt-4" href="https://play.google.com/store/apps/details?id=it.circl.android" target="_blank"><img class="hvr" src="https://circl.it/wp-content/uploads/2019/05/playstore-button-300x101.png" style="width: 140px; height: 50px;"/></a>
          <p class="font-6 d-flex align-self-start mt-4 mb-0">For Merchants:  CIRCL Store</p>
          <a class="align-self-start mt-4" href="https://apps.apple.com/us/app/circl-store-contactless-pickup/id1508987483" target="_blank"><img class="hvr" src="https://circl.it/wp-content/uploads/2019/05/appstore-button-300x101.png" style="width: 140px; height: 50px;"/></a>
          <a class="align-self-start mt-4" href="https://play.google.com/store/apps/details?id=it.circl.merchant.flutter" target="_blank"><img class="hvr" src="https://circl.it/wp-content/uploads/2019/05/playstore-button-300x101.png" style="width: 140px; height: 50px;"/></a>
          <p class="font-6 d-flex align-self-start mt-4 mb-0">FoodTrail – like Tinder for food</p>
          <a class="align-self-start mt-4" href="https://apps.apple.com/us/app/foodtrail/id1477147814" target="_blank"><img class="hvr" src="https://circl.it/wp-content/uploads/2019/05/appstore-button-300x101.png" style="width: 140px; height: 50px;"/></a>
          <a class="align-self-start mt-4" href="https://play.google.com/store/apps/details?id=it.circl.foodtrail.android" target="_blank"><img class="hvr" src="https://circl.it/wp-content/uploads/2019/05/playstore-button-300x101.png" style="width: 140px; height: 50px;"/></a>
        </div>
        <div class="d-flex flex-column align-self-start footer-content-right">
          <a class="font-5 hvr" href="https://circl.it/store/" target="_blank"><p class="d-flex align-self-start mb-3"><strong>I’m a Merchant</strong></p></a>
          <a class="font-5 hvr" href="https://www.straitstimes.com/business/economy/tech-firms-help-smes-sell-food-products-online" target="_blank"><p class="d-flex align-self-start mb-3"><strong>Media Coverage</strong></p></a>
          <a class="font-5 hvr" href="https://circl.it/faq/"><p class="d-flex align-self-start mb-3"><strong>FAQ</strong></p></a>
          <a class="font-5 hvr" href="https://circl.it/press-release/"><p class="d-flex align-self-start mb-3"><strong>Press Release</strong></p></a>
          <a class="font-5 hvr" href="https://circl.it/kit/"><p class="d-flex align-self-start mb-3"><strong>Marketing & Media Kit</strong></p></a>
          <a class="font-5 hvr" href="https://circl.it/terms-and-condition/"><p class="d-flex align-self-start mb-3"><strong>Terms & Conditions</strong></p></a>
          <a class="font-5 hvr" href="https://circl.it/privacy-policy/"><p class="d-flex align-self-start mb-3"><strong>Privacy Policy</strong></p></a>
          <p class="font-5 d-flex align-self-start mb-5"><strong>info@circl.it</strong></p>
          <p class="font-5 d-flex align-self-start mb-3"><strong>Copyright CIRCL Pte. Ltd. 2020 | All rights reserved</strong></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardSubscription from '../components/CardSubscription'
import axios from 'axios'

export default {
  name: 'SubscriptionPage',
  components: {
    CardSubscription
  },
  data () {
    return {
      sg: false,
      subs_plan_1: {
        name: 'Monthly',
        description: 'Monthly billing',
        type: 'monthly',
        price: Number(process.env.VUE_APP_MONTHLY_GOPRO_PRICE),
        price_id: process.env.VUE_APP_MONTHLY_GOPRO_PRICE_ID,
        free_trial_days: 3,
        coupon: null,
        coupon_value: 0
      },
      subs_plan_2: {
        name: 'Annual',
        description: 'Annual billing',
        type: 'yearly',
        price: Number(process.env.VUE_APP_YEARLY_GOPRO_PRICE),
        price_id: process.env.VUE_APP_YEARLY_GOPRO_PRICE_ID,
        free_trial_days: 3,
        coupon: null,
        coupon_value: 0
      },
      subs_plan_3: {
        name: 'Prepaid',
        description: 'Prepay first two years, then annual billing',
        type: 'yearly',
        price: Number(process.env.VUE_APP_PREPAID_PRICE),
        price_id: process.env.VUE_APP_PREPAID_PRICE_ID,
        free_trial_days: 3,
        coupon: null,
        coupon_value: 0
      }
    }
  },
  methods: {
    initialize () {
      const promotion = this.$route.query.code
      const path = this.$route.path
      if (path === '/pricing') {
        if (promotion === 'SECRET') {
          this.subs_plan_2.coupon = process.env.VUE_APP_SECRET_COUPON
          this.subs_plan_2.coupon_value = 240
          this.subs_plan_2.free_trial_days = 0
        } else if (promotion === 'INNERCIRCL') {
          this.subs_plan_2.coupon = process.env.VUE_APP_INNERCIRCL_COUPON
          this.subs_plan_2.coupon_value = 180
          this.subs_plan_2.free_trial_days = 0
        } else if (promotion === 'FRIEND') {
          this.subs_plan_2.coupon = process.env.VUE_APP_FRIEND_COUPON
          this.subs_plan_2.coupon_value = 120
          this.subs_plan_2.free_trial_days = 0
        } else if (promotion === 'FOODTRAIL') {
          this.subs_plan_2.coupon = process.env.VUE_APP_FOODTRAIL_COUPON
          this.subs_plan_2.coupon_value = 60
          this.subs_plan_2.free_trial_days = 0
        } else if (promotion === 'PARTNER30') {
          this.subs_plan_1.coupon = process.env.VUE_APP_PARTNER30_COUPON
          this.subs_plan_1.coupon_value = 15
          this.subs_plan_1.free_trial_days = 14
        }
      } else if (path === '/sg/pricing') {
        this.sg = true
        this.subs_plan_1.price = Number(process.env.VUE_APP_MONTHLY_PRICE_SG)
        this.subs_plan_1.price_id = process.env.VUE_APP_MONTHLY_PRICE_ID_SG
        this.subs_plan_2.price = Number(process.env.VUE_APP_YEARLY_PRICE_SG)
        this.subs_plan_2.price_id = process.env.VUE_APP_YEARLY_PRICE_ID_SG
        this.subs_plan_3.price = Number(process.env.VUE_APP_PREPAID_PRICE_SG)
        this.subs_plan_3.price_id = process.env.VUE_APP_PREPAID_PRICE_ID_SG
      }
      if (promotion === 'DIRECT') {
        this.subs_plan_2.free_trial_days = 0
      } else if (promotion === 'FREEWEEK') {
        this.subs_plan_2.free_trial_days = 7
      } else if (promotion === '1MONTH') {
        this.subs_plan_1.free_trial_days = 30
      } else if (promotion === 'PAID1YR') {
        this.subs_plan_2.free_trial_days = 365
      } else if (promotion === '2INVOICEYRS') {
        this.subs_plan_2.free_trial_days = 730
      } else if (promotion === 'ANNUAL30') {
        this.subs_plan_2.free_trial_days = 30
      } else if (promotion === 'MONTHLY30') {
        this.subs_plan_1.free_trial_days = 30
      } else if (promotion === '2YEAR30') {
        this.subs_plan_3.free_trial_days = 30
      } else if (promotion === '90YRLY') {
        this.subs_plan_2.free_trial_days = 90
      } else if (promotion === '90MNTHL') {
        this.subs_plan_1.free_trial_days = 90
      } else if (promotion === '902YRS') {
        this.subs_plan_3.free_trial_days = 90
      }
    },
    open () {
      const item = localStorage.getItem('mySubscription')
      item === null ? this.$router.push('/login') : this.$router.push('/subscription-payment')
    },
    toSG () {
      // window.location.href(`${window.location.host}/sg/pricing`)
      window.location.href = `http://${window.location.host}/sg/pricing`
    },
    toGlobal () {
      window.location.href = `http://${window.location.host}/pricing`
    }
  },
  created () {
    this.initialize()
  },
  async mounted () {
    // const r = await axios.get('https://api64.ipify.org')
    const x = await axios.get('https://ipapi.co/json/')
    const ip = sessionStorage.getItem('ip_origin')
    if (!ip) {
      if (x.status === 200) {
        sessionStorage.setItem('ip_origin', x.data.country)
      }
      if (x.data.country === 'SG') {
        this.toSG()
      } else {
        this.toGlobal()
      }
    }
  }
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap');

.wrapper {
  margin-left: auto;
  margin-right: auto;
  max-width: 1250px;
  height: 100%;
}
.card-subscription-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
.additional-info-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  width: 90%;
}
.card-option-wrapper {
  width: 420px;
  border-width: 2px;
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}
.wrapo {
  width: 100vw;
  height: 100vh;
}
.button-1 {
  height: 40px;
  width: 240px;
  padding: 16px;
  color: white;
  background-color: #0690C7;
  border-radius: 5px;
}
.button-sg-pricing {
  padding: 8px;
  background-color: #ebf7f7;
  color: #3f91bd;
  border: none;
}
.font-1 {
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 30px;
  font-weight: 600;
  color: black;
}
.font-2 {
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 18px;
  color: black;
}
.font-3 {
  font-family: 'Roboto', sans-serif;
  font-weight:700;
  color: #cdd0d0;
  font-size: 14px;
  padding-right: 20px;
  text-decoration:none;
}
.font-4 {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  color: white;
  font-size: 28px;
  padding-bottom: 4px;
}
.font-5 {
  font-family: 'Roboto', sans-serif;
  color: white;
  font-size: 14px;
   text-decoration:none;
}
.font-6 {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  color: white;
  font-size: 16px;
  padding-bottom: 4px;
}
.hvr:hover {
  cursor: pointer;
  color: #e7e6e6;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #0690C7;
  -webkit-transition: .4s;
  transition: .4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
input:checked + .slider {
  background-color: #0690C7;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.footer {
  max-height: 1000px;
  width: 100%;
  background: url('https://circl.it/wp-content/uploads/2019/05/homepage-background.png');
  background-size: 100vw 100vh;
}
.header {
  background-color: #28a8cf;
}
.solid {
  border-top: 1px solid white;
  width: 280px;
}
.footer-content-left {
  margin-left: 160px;
  margin-right: 200px
}
.footer-content-right {
 margin-top: 60px;
}
@media (max-width: 768px) {
  .footer-content-left {
    margin-left: 40px;
  }
  .footer-content-right {
    margin-top: 80px;
    margin-left: 40px;
  }
}
@media (max-width: 480px) {
  .card-option-wrapper {
    width: 90%;
  }
}
.flex-column:before, .flex-column:after {
    display: inline-block;
}
</style>
